import request from "@utils/request";

/**
 * 校验 code 是否已使用
 * @param {string} code - 需要校验的 code 值
 * @returns {Promise}
 */
export function checkCode(code) {
  return request.get("/check_code", { code }, { login: false });
}

/**
 * 查询溯源码详情(扫码查询)
 * @param {string} code - 溯源码
 * @returns {Promise}
 */
export function getTraceabilityCodeInfo(code) {
  return request.get(`/traceability/code/info/${code}`, {}, { login: false });
}

/**
 * 核销溯源码
 * @param {string} code - 溯源码
 * @returns {Promise}
 */
export function verifyTraceabilityCode(code) {
  return request.post("/traceability/code/verify", { code }, { login: false });
}

/**
 * 商品追溯分页列表
 * @param {object} params - 查询参数
 * @returns {Promise}
 */
export function getProductTraceabilityList(params) {
  return request.get("/product/traceability/page/list", params);
}

/**
 * 商品追溯详情
 * @param {number} id - 商品追溯ID
 * @returns {Promise}
 */
export function getProductTraceabilityInfo(id) {
  return request.get(`/traceability/code/product/traceability/info/${id}`, {}, { login: false });
}

/**
 * 生成微信小程序加密URLLink
 * @param {object} data - { path, query, expireInterval }
 * @returns {Promise}
 */
export function generateUrlLink(data) {
  return request.post("/wechat/generate/url/link", data, { login: false });
}
